import { useUser } from './useUser';

/**
 * Hook to check if all required settings are complete
 * @returns Object containing hasIncompleteSettings flag and loading state
 */
export const useSettingsCompleteness = () => {
  const { user, loading } = useUser();

  // Check each required field (API key is optional)
  const hasIncompleteSettings =
    !user?.name?.trim() ||
    !user?.companyName?.trim() ||
    !user?.businessField?.trim() ||
    !user?.skr;

  return {
    hasIncompleteSettings: !loading && hasIncompleteSettings,
    loading,
  };
};
